<template>
    <v-navigation-drawer
            :value="drawer"
            fixed
            clipped
            app
            @input="barToggled"
    >
        <v-list dense>
            <v-list-tile @click="$router.push({name: 'default'})">
                <v-list-tile-action>
                    <v-icon>dashboard</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Dashboard</v-list-tile-title>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile @click="$router.push({name: 'admin.users.search'})">
                <v-list-tile-action>
                    <v-icon>supervisor_account</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Users</v-list-tile-title>
            </v-list-tile>

            <v-list-tile @click="$router.push({name: 'admin.companies.search'})">
                <v-list-tile-action>
                    <v-icon>business</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Companies</v-list-tile-title>
            </v-list-tile>

            <v-list-group
                    prepend-icon="card_membership"
                    no-action
            >
                <v-list-tile slot="activator">
                    <v-list-tile-content><v-list-tile-title>Awards</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :href="ordersURL">
                    <v-list-tile-content><v-list-tile-title>Orders</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :href="entriesURL">
                    <v-list-tile-content><v-list-tile-title>Entries</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :href="deliveryURL">
                    <v-list-tile-content><v-list-tile-title>Delivery</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :href="goodsInURL">
                    <v-list-tile-content><v-list-tile-title>Goods In</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :href="judgingURL">
                    <v-list-tile-content><v-list-tile-title>Judging</v-list-tile-title></v-list-tile-content>
                </v-list-tile>
            </v-list-group>

            <!--<v-list-group-->
                    <!--prepend-icon="import_export"-->
                    <!--no-action-->
            <!--&gt;-->
                <!--<v-list-tile slot="activator">-->
                    <!--<v-list-tile-content><v-list-tile-title>Import/Export</v-list-tile-title></v-list-tile-content>-->
                <!--</v-list-tile>-->

                <!--<v-list-tile @click="$router.push({name: 'dataops'})">-->
                    <!--<v-list-tile-content>-->
                        <!--<v-list-tile-title>Dashboard</v-list-tile-title>-->
                    <!--</v-list-tile-content>-->
                <!--</v-list-tile>-->
            <!--</v-list-group>-->

            <v-list-tile @click="$router.push({name: 'dataops'})">
                <v-list-tile-action>
                    <v-icon>import_export</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Import/Export</v-list-tile-title>
            </v-list-tile>

            <div class="text-xs-center mt-5">
                <small class="font-weight-light">Version {{version}}</small>
            </div>
            <!--<v-list-tile @click="$router.push({name: 'admin.users.search'})">-->
                <!--<v-list-tile-action>-->
                    <!--<v-icon>search</v-icon>-->
                <!--</v-list-tile-action>-->
                <!--<v-list-tile-title>Search Test</v-list-tile-title>-->
            <!--</v-list-tile>-->

            <!--<v-list-tile @click="$router.push({name: 'tab.dashboard'})">-->
                <!--<v-list-tile-action>-->
                    <!--<v-icon>search</v-icon>-->
                <!--</v-list-tile-action>-->
                <!--<v-list-tile-title>Tab Test</v-list-tile-title>-->
            <!--</v-list-tile>-->
        </v-list>
    </v-navigation-drawer>
</template>

<script>
  export default {
    name: 'LeftNav',
    props: {
      drawer: {
        required: true,
        default: null
      },
      systemConfig: {
        type: Object,
        required: true
      },
      user: {
        required: true
      }
    },
    computed: {
      ordersURL () {
        return `${this.systemConfig.urls.admin}/admin/orders/search`
      },
      entriesURL () {
        return `${this.systemConfig.urls.admin}/admin/entries/search`
      },
      deliveryURL () {
        return `${this.systemConfig.urls.admin}/admin/deliverylocations`
      },
      goodsInURL () {
        return `${this.systemConfig.urls.admin}/admin/goodsin/search`
      },
      judgingURL () {
        return `${this.systemConfig.urls.admin}/admin/judging/sessions`
      },
      version () {
        try {
          return this.$firebaseClient.clientVersion
        } catch (e) {
          return 'n/a'
        }
      }
    },
    methods: {
      barToggled (state) {
        this.$emit('navStateChanged', state)
      }
    }
  }
</script>

<style scoped>

</style>
